import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    firstName: "",
    lastName: "",
    destination: "",
    password: "",
    email: "",
    confirmPassword: "",
    getUserData: [],
    getActiveUserData: [],
    getUserRole: [],
    getUserDataWithoutRole: []
}

const UserManagementReducer = (state = initState, { type, payload }) => {


    switch (type) {
        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.USER_FIRST_NAME_UPDATE:
            return {
                ...state,
                firstName: payload.value
            }

        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.USER_LAST_NAME_UPDATE:
            return {
                ...state,
                lastName: payload.value
            }

        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.USER_EMAIL_UPDATE:
            return {
                ...state,
                email: payload.value
            }

        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.USER_PASSWORD_UPDATE:
            return {
                ...state,
                password: payload.value
            }

        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.USER_CONFIRM_PASSWORD_UPDATE:
            return {
                ...state,
                confirmPassword: payload.value
            }

        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_API_SUCCESS:

            return {
                ...state,
                getUserData: payload.value
            }

        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_ACTIVE_USER_MANAGEMENT_API_SUCCESS:

            return {
                ...state,
                getActiveUserData: payload.value
            }

        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_ROLES_MANAGEMENT_API_SUCCESS:
            return {
                ...state,
                getUserRole: payload.value
            }

        case CONSTANTS.CONSTANTS_USER_MANAGEMENT.GET_USER_DATA_SUCCESS:
            return {
                ...state,
                getUserDataWithoutRole: payload.value
            }

        default:
            return state
    }
}

export default UserManagementReducer;
